"use client";
import React from "react";
import { motion } from "framer-motion";
import { Caveat } from "next/font/google";
import Image from "next/image";

const caveat = Caveat({ subsets: ["latin"], weight: ["400", "700"], display: "swap" });

export default function IndustryFeaturesGrid({ data = {} }) {
  const featuresGrid = data?.featuresGrid || [];
  if (!featuresGrid.length) return null;

  return (
    <section className="relative overflow-hidden bg-white/5 rounded-tl-[180px] pt-16 pb-24 px-6 sm:px-12 lg:px-24">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_0%,rgba(255,255,255,0.30),transparent_40%),radial-gradient(circle_at_100%_0%,rgba(255,255,255,0.05),transparent_30%)]" />
      <div className="container relative mx-auto">
        <div className="mb-14 max-w-3xl">
          <h2 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-white ${caveat.className}`}>
            All the <span className="relative inline-block">
              <span className="relative z-10">features</span>
              <Image
                src="/odoo/graphics/circle.svg"
                alt=""
                width={190}
                height={190}
                aria-hidden="true"
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rotate-[-8deg] select-none pointer-events-none object-contain"
              />
            </span>
            <br />
            done <span className="relative inline-block">
              <span className="relative z-10">right</span>
              <span className="absolute -bottom-1 left-0 h-2 w-full rounded-full bg-orange-400/90 rotate-[-2deg]" />
            </span><span className="text-orange-300">.</span>
          </h2>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {featuresGrid.map((feature, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -5 }}
              className="rounded-2xl border border-white/10 bg-white/5 p-8 sm:p-10 shadow-[0_18px_50px_rgba(15,23,42,0.08)] transition-all hover:shadow-[0_24px_60px_rgba(15,23,42,0.12)]"
            >
              <h4 className="mb-4 text-xl sm:text-2xl font-semibold tracking-tight text-white">
                {feature.title}
              </h4>
              <p className="max-w-xl text-base leading-7 text-gray-200">
                {feature.desc}
              </p>
              {feature.linkLabel && feature.link && (
                <a
                  href={feature.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-5 inline-flex items-center gap-2 text-base font-medium text-white transition-colors hover:text-sky-500"
                >
                  <span className="border-b border-current pb-0.5">{feature.linkLabel}</span>
                  <Image
                    src="/odoo/arrows/secondary_arrow_sm_03.svg"
                    width={30}
                    height={30}
                    className="align-baseline object-contain"
                    alt=""
                  />
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
